"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CookieBanner", {
    enumerable: true,
    get: function() {
        return CookieBanner;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _reactutils = require("@chakra-ui/react-utils");
var _components = require("@cmpsr/components");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _createContext = _sliced_to_array((0, _reactutils.createContext)({
    name: "CookieBannerContext"
}), 2), CookieBannerProvider = _createContext[0], useCookieBannerContext = _createContext[1];
var CookieBanner = function(_param) {
    var children = _param.children, _param_cookieKey = _param.cookieKey, cookieKey = _param_cookieKey === void 0 ? "cmpsr-cookies-policy" : _param_cookieKey, _param_cookieVersion = _param.cookieVersion, cookieVersion = _param_cookieVersion === void 0 ? "1.0.0" : _param_cookieVersion, rest = _object_without_properties(_param, [
        "children",
        "cookieKey",
        "cookieVersion"
    ]);
    var _useState = _sliced_to_array((0, _react.useState)(false), 2), shouldShow = _useState[0], setShouldShow = _useState[1];
    var _useState1 = _sliced_to_array((0, _react.useState)(undefined), 2), cookiePolicy = _useState1[0], setCookiePolicy = _useState1[1];
    (0, _react.useEffect)(function() {
        var currentPolicy = localStorage.getItem(cookieKey);
        if (currentPolicy) {
            setCookiePolicy(currentPolicy);
        } else {
            setCookiePolicy("");
        }
    }, []);
    (0, _react.useEffect)(function() {
        if (cookiePolicy === undefined) return;
        if (cookiePolicy === "") {
            setShouldShow(true);
            return;
        }
        var policy = JSON.parse(cookiePolicy);
        if (policy["cookieVersion"] === cookieVersion) {
            setShouldShow(false);
            return;
        }
        setShouldShow(true);
    }, [
        cookiePolicy
    ]);
    var updatePolicy = function(allowed) {
        var newPolicy = JSON.stringify({
            cookieVersion: cookieVersion,
            allow: allowed
        });
        localStorage.setItem(cookieKey, newPolicy);
        setCookiePolicy(newPolicy);
    };
    var allowAllCookies = function() {
        return updatePolicy("all");
    };
    var allowRequiredOnly = function() {
        return updatePolicy("required");
    };
    var areActionsDefined = _react.default.Children.map(children, function(child) {
        return (0, _react.isValidElement)(child) && child.type === CookieBannerActions;
    }).some(Boolean);
    return _react.default.createElement(CookieBannerProvider, {
        value: {
            allowAllCookies: allowAllCookies,
            allowRequiredOnly: allowRequiredOnly,
            cookiePolicy: cookiePolicy
        }
    }, shouldShow ? _react.default.createElement(_components.Flex, _object_spread({
        direction: {
            base: "column",
            lg: "row"
        },
        alignItems: "center",
        bg: "background-inform",
        pr: "1rem",
        py: "1.5rem"
    }, rest), children, !areActionsDefined && _react.default.createElement(CookieBanner.Actions, null, _react.default.createElement(CookieBanner.Actions.AcceptRequired, null), _react.default.createElement(CookieBanner.Actions.AcceptAll, null))) : null);
};
var CookieBannerContent = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return _react.default.createElement(_components.Alert, _object_spread({
        variant: "subtle",
        pt: "0",
        pr: {
            base: "0",
            lg: "2rem"
        },
        pb: {
            base: "2rem",
            lg: "0"
        }
    }, props), _react.default.createElement(_components.Alert.Icon, null), typeof children === "string" ? _react.default.createElement(_components.Text, {
        color: "text-secondary"
    }, children) : children);
};
CookieBanner.Content = CookieBannerContent;
var CookieBannerActionAcceptAll = function(_param) {
    var onClick = _param.onClick, _param_children = _param.children, children = _param_children === void 0 ? "Allow all Cookies" : _param_children, props = _object_without_properties(_param, [
        "onClick",
        "children"
    ]);
    var allowAllCookies = useCookieBannerContext().allowAllCookies;
    var handleClick = function(event) {
        var _onClick;
        allowAllCookies();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    };
    return _react.default.createElement(_components.Button, _object_spread({
        variant: "primary",
        onClick: handleClick
    }, props), children);
};
var CookieBannerActionAcceptRequired = function(_param) {
    var onClick = _param.onClick, _param_children = _param.children, children = _param_children === void 0 ? "Allow functional only" : _param_children, props = _object_without_properties(_param, [
        "onClick",
        "children"
    ]);
    var allowRequiredOnly = useCookieBannerContext().allowRequiredOnly;
    var handleClick = function(event) {
        var _onClick;
        allowRequiredOnly();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    };
    return _react.default.createElement(_components.Button, _object_spread({
        variant: "link",
        onClick: handleClick
    }, props), children);
};
var CookieBannerActions = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        justifyContent: "center",
        alignItems: "center",
        direction: {
            base: "column",
            lg: "row"
        },
        gap: "1.5rem"
    }, props));
};
CookieBannerActions.AcceptAll = CookieBannerActionAcceptAll;
CookieBannerActions.AcceptRequired = CookieBannerActionAcceptRequired;
CookieBanner.Actions = CookieBannerActions;
